// extracted by mini-css-extract-plugin
export var quillEditor = "_n0-1";
export var variable = "_n0-0";